
// Helper functions and constants for the Hero component

// Height class mapping
export const heightClasses = {
  small: 'min-h-[20vh]',
  medium: 'min-h-[50vh]',
  large: 'min-h-[70vh]',
  full: 'min-h-screen'
};

// Overlay opacity class mapping
export const overlayClasses = {
  light: 'bg-black/20',
  medium: 'bg-black/35',
  heavy: 'bg-black/50'
};

// Image filter classes mapping - enhancing brightness and contrast for better text visibility without overlays
export const imageStyleClasses = {
  darken: 'brightness-75 contrast-110',
  darker: 'brightness-60 contrast-115', // Added support for 'darker'
  natural: 'brightness-90 contrast-105',
  brighten: 'brightness-105 contrast-110 saturate-105',
  blur: 'brightness-80 filter blur-sm' // Added support for 'blur'
};

// Content position classes mapping
export const contentPositionClasses = {
  left: 'md:text-left text-center',
  center: 'text-center items-center justify-center',
  right: 'md:text-right text-center',
  top: 'text-center items-center justify-start',
  bottom: 'text-center items-center justify-end'
};

// Generate urgency message based on current date
export const generateUrgencyMessage = () => {
  const currentDate = new Date();
  const currentMonth = currentDate.toLocaleString('default', { month: 'long' });
  const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
    .toLocaleString('default', { month: 'long' });
  
  // If we're in the later part of the month (after the 15th), show next month
  const dayOfMonth = currentDate.getDate();
  const monthToShow = dayOfMonth > 15 ? nextMonth : currentMonth;
  
  return `Summer 2025 – Spots Filling Fast for ${monthToShow} Tours!`;
};
